import { endpoints } from "./endpoints";
import client from "../lib/crypto/client";
import { publicKey } from "../lib/crypto/key";
import NodeRSA from "node-rsa";
import globalVariable from "./globalVariable";
import { decrypt } from "../helper/methods";

const isCrypto = process.env.REACT_APP_CRYPTO === "on" ? true : false;
const secureResponse = process.env.REACT_APP_ENABLE_RESPONSE_ENCODING;

const getFetchBadAssSecure = () => {
  if ("object" === typeof window) {
    let getBadObj =
      "object" === typeof window.badAssGuys
        ? window.badAssGuys.badAssSecure
        : ""; // "6693614066929259"
    return getBadObj;
  } else {
    return "";
  }
};

const fetchHeader = {
  "Content-Type": "application/json",
  "User-Agent": "WEB/MultipleCampaign",
  "user-agent": "WEB/MultipleCampaign",
  UserAgent: "WEB/MultipleCampaign",
  "secure-response": !!secureResponse,
}; //"appId":data
const fetchHeaderFile = {
  "Content-Type": "application/json",
  mimeType: "multipart/form-data",
};


const getDecryptedResponse = (res) => {
  console.log('isSecureResponse', res);
  const decryptedResponse = JSON.parse(decrypt(res.data, process.env.REACT_APP_ENC_KEY));
  console.log('decryptedResponse', decryptedResponse);
  return decryptedResponse
}

export default class Api {
  constructor() {
    this.crypto = new client(); //crypto instance
  }

  encrypt = (data) => {
    console.log(
      "MY DATA ========@@@@@@@@@@@@@@@@@@@@@@@================@@@@@@@@@@@@@@@@@@@@@@@================@@@@@@@@@@@@@@@@@@@@@@@========",
      data
    );
    const encrypt = new NodeRSA(publicKey);
    let encryptedParams = encrypt.encrypt(data, "base64");
    console.log(
      "MY DATA ========@@@@@@@@@@@@@@@@@@@@@@@================@@@@@@@@@@@@@@@@@@@@@@@================@@@@@@@@@@@@@@@@@@@@@@@========",
      encryptedParams
    );
    return encryptedParams;
    // let encryptedText = this.crypto.encryptBody(data);
    // return encryptedText;
  };

  fetch = (url, method, body, overrideHeader = {}) => {
    let opt = {
      method: method,
      headers: { ...fetchHeader, ...overrideHeader },
      body: body,
      //credentials: 'same-origin'
    };

    let getBadAssGuySecure = getFetchBadAssSecure(); // fetch the bad ass secure guy
    if (getBadAssGuySecure) {
      // add the encrypted AES key to header
      opt.headers.meta = getBadAssGuySecure;
    }

    if (body && isCrypto) {
      // add encrypted body if crypto is on
      let encryptedBody = { body: this.crypto.encryptBody(body) };
      console.log("encryptedBody", encryptedBody);
      opt.body = JSON.stringify(encryptedBody);
    }
    console.log("fetchSujeet", url, opt);

    let isSecureResponse;
    return fetch(url, opt).then((response) => {
      isSecureResponse = response.headers.get('secure-response');
      return response.json()
    }).then(res => {

      console.log("checking at line 94 a: ", isSecureResponse)
      const response = isSecureResponse ? getDecryptedResponse(res) : res;
      console.log("checking at line 94 b: ", response)

      if (response.hasOwnProperty('code')) {
        if (response?.data?.code === 401 || response?.code === 401 || response?.status === 401) {
          let events = globalVariable?.getPropertyByName("events");
          events.publish('httpError', 'failed');
          return response;
        } else {
          return response;
        }
      } else {
        return response;
      }
    }).catch(error => {
      console.log("error")
    });
  };

  fetchFile = (url, method, body) => {
    let opt = {
      method: method,
      headers: fetchHeaderFile,
      body: body,
      credentials: "same-origin",
    };

    return fetch(url, opt).then((response) => response.json());
  };
  fetchNormal = (url, method, body) => {
    let opt = {
      method: method,
      headers: fetchHeader,
      body: body,
      //credentials: 'same-origin'
    };

    let getBadAssGuySecure = getFetchBadAssSecure(); // fetch the bad ass secure guy
    if (getBadAssGuySecure) { // add the encrypted AES key to header
      opt.headers.meta = getBadAssGuySecure;
      opt.headers.appid = "37F92DDEMBBE0A4F8EM9589CD5DC00656CD9";
    }

    const apiNames = ["GetSchemeDetForSIPDashboard", "getGeneralBanners"];
    const apiNameSet = new Set(apiNames); // used for large collection

    const urlContainsAPI_NameSet = (url) => {
      if (!url) return false;

      // const lowerCaseUrl = url.toLowerCase();
      for (const apiName of apiNameSet) {
        if (url.includes(apiName)) {
          return true;
        }
      }
      return false;
    };

    let isEncryptAPIReq = urlContainsAPI_NameSet(url);
    if (body && isCrypto && isEncryptAPIReq) {// add encrypted body if crypto is on
      let encryptedBody = { body: this.crypto.encryptBody(body) };
      console.log("EncryptedBody: ", encryptedBody)
      opt.body = JSON.stringify(encryptedBody);
    }

    let isSecureResponse;
    return fetch(url, opt).then((response) => {
      isSecureResponse = response.headers.get('secure-response');
      return response.json()
    }
    ).then(res => {
      const response = isSecureResponse ? getDecryptedResponse(res) : res;
      return response;
    });

    // return fetch(url, opt).then((response) => response.json());
  };

  buildUrl = (path, urlType = "") => {
    if (urlType === "full") {
      return `${path}`;
    } else {
      return `${endpoints.baseUrl}${path}`;
    }
  };
}
